import { render, staticRenderFns } from "./OrderListing.vue?vue&type=template&id=05b2a1b3&scoped=true"
import script from "./OrderListing.vue?vue&type=script&lang=js"
export * from "./OrderListing.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./OrderListing.vue?vue&type=style&index=0&id=05b2a1b3&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "05b2a1b3",
  null
  ,true
)

export default component.exports